import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getFinancialAccountTypeListSaga = createAction(
  "GET_FINANCIAL_ACCOUNT_TYPE",
  ({ payload, params }: SagaActionParams<Type.FinancialAccountTypeDto[]>) => ({
    payload,
    url: "/api/admin/adminfinancialaccounttypes" + (params ? params : ""),
  })
);
export const getFinancialAccountTypeDetailsSaga = createAction(
  "GET_FINANCIAL_ACCOUNT_TYPE_DETAILS",
  ({ payload, id }: SagaActionParams<Type.FinancialAccountTypeDetailDto>) => ({
    payload,
    url: "/api/admin/adminfinancialaccounttypes/" + id,
  })
);
export const createFinancialAccountTypeSaga = createAction(
  "CREATE_FINANCIAL_ACCOUNT_TYPE",
  ({ payload, body }: SagaActionParams<Type.FinancialAccountTypeDto>) => ({
    payload,
    url: "/api/admin/adminfinancialaccounttypes",
    body,
  })
);
export const updateFinancialAccountTypeSaga = createAction(
  "UPDATE_FINANCIAL_ACCOUNT_TYPE",
  ({ payload, id, body }: SagaActionParams<Type.FinancialAccountTypeDto>) => ({
    payload,
    url: "/api/admin/adminfinancialaccounttypes/" + id,
    body,
  })
);
export const deleteFinancialAccountTypeSaga = createAction(
  "DELETE_FINANCIAL_ACCOUNT_TYPE",
  ({ payload, id }: SagaActionParams<Type.FinancialAccountTypeDto>) => ({
    payload,
    url: "/api/admin/adminfinancialaccounttypes/" + id,
  })
);

const financialAccountTypeSaga = [
  takeLatest<any>(
    getFinancialAccountTypeListSaga.toString(),
    (payload: SagaGenericParams<Type.FinancialAccountTypeDto[]>) =>
      getSaga<Type.FinancialAccountTypeDto[]>(payload)
  ),
  takeLatest<any>(
    getFinancialAccountTypeDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.FinancialAccountTypeDetailDto>) =>
      getSaga<Type.FinancialAccountTypeDetailDto>(payload)
  ),
  takeLatest<any>(
    createFinancialAccountTypeSaga.toString(),
    (payload: SagaGenericParams<Type.FinancialAccountTypeDto>) =>
      postSaga<Type.FinancialAccountTypeDto>(payload)
  ),
  takeLatest<any>(
    updateFinancialAccountTypeSaga.toString(),
    (payload: SagaGenericParams<Type.FinancialAccountTypeDto>) =>
      putSaga<Type.FinancialAccountTypeDto>(payload)
  ),
  takeLatest<any>(
    deleteFinancialAccountTypeSaga.toString(),
    (payload: SagaGenericParams<any>) =>
      deleteSaga<Type.FinancialAccountTypeDto>(payload)
  ),
];

export default financialAccountTypeSaga;
